const hogCreateErrorCodes = {
  e0000: {
    preamble_text: 'An error occurred while creating your HOG membership',
    resolution_text: 'Sit tight and we will reach out to you',
    auto_submit_ticket: true,
    ticket_vars: ['email', 'phone', 'first_name', 'last_name'],
  },
  e0001: {
    preamble_text: 'We were unable to create your HOG membership',
    resolution_text:
      'We have already opened a support ticket. Someone will contact you shortly.',
    auto_submit_ticket: true,
    ticket_vars: ['email', 'phone', 'first_name', 'last_name'],
  },
  e0002: {
    preamble_text: 'We were unable to add your HOG membership',
    resolution_text:
      'We have already opened a support ticket. Someone will contact you shortly.',
    auto_submit_ticket: true,
    ticket_vars: ['email', 'phone', 'first_name', 'last_name'],
  },
};

export default hogCreateErrorCodes;
